exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.save-button[data-v-44590e6e] {\n  width: 20px;\n  position: relative;\n}\n.icon-heart-animating[data-v-44590e6e] {\n  left: 0;\n  top: 2px;\n}\n.loading[data-v-44590e6e] {\n  animation: lds-heart-data-v-44590e6e 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n@keyframes lds-heart-data-v-44590e6e {\n0% {\n    transform: scale(0.95);\n}\n5% {\n    transform: scale(1.3);\n}\n39% {\n    transform: scale(0.85);\n}\n45% {\n    transform: scale(1.2);\n}\n60% {\n    transform: scale(0.95);\n}\n100% {\n    transform: scale(0.9);\n}\n}", ""]);

// exports
